// products.images is JSONB — either a string URL, or an array of strings,
// or an array of {thumb, med, full} objects. This resolver returns the best
// URL for the requested size, falling back through variants.
export function resolveImage(images, size = "med") {
  if (!images) return null;
  const arr = Array.isArray(images) ? images : [images];
  const first = arr[0];
  if (!first) return null;
  if (typeof first === "string") return first;
  if (typeof first === "object") {
    return first[size] || first.med || first.full || first.thumb || null;
  }
  return null;
}
